import classnames from 'classnames';

export const themes = {
  default: ({ hasImageBorder, hasLink, isHovering }) => ({
    thRoot: '',
    thLink: classnames('bg-black block overflow-hidden relative', {
      'decoration-fancy-frame': hasImageBorder,
    }),
    thThumbnail: classnames({
      'transition-transform-opacity': hasLink,
      'opacity-50 scale-105 ': hasLink && isHovering,
    }),
    thLabel: classnames(
      'absolute px-1 text-center text-md text-shadow-1 text-white -translate-y-50 w-full',
      {
        'top-1/2': !isHovering,
        'top-9/20': isHovering,
      },
    ),
    thLabelStyle: {
      ...(isHovering
        ? {
            top: '45%',
            transition: 'all ease-in 0.25s',
          }
        : {
            top: '50%',
            transition: 'all ease-in 0.25s 0.15s',
          }),
    },
    thSeeMoreLabel:
      'absolute flex items-center justify-center leading-one text-center text-shadow-1 text-white uppercase w-full',
    thSeeMoreLabelStyle: {
      fontSize: '0.6875rem',
      ...(isHovering
        ? {
            bottom: '30%',
            opacity: 1,
            transition: 'all ease-in 0.15s 0.2s',
          }
        : {
            bottom: '27%',
            opacity: 0,
            transition: 'all ease-in 0.15s',
          }),
    },
    thSeeMoreIcon: 'mx-1',
    thSeeMoreIconSize: '0.625rem',
    thBody: 'p-3',
  }),
};
